import useApi from "@/composables/useApi";
import { Route } from "@/models/api/Route";
import { keepPreviousData, useQuery } from "@tanstack/vue-query";

const useRoutesQuery = () => {
    const { get } = useApi();

    const getRoutes = () => {
        return get<Route[]>("/api/SailingManager/GetRoutes").then((resp) => {
            return resp.data ?? [];
        });
    };

    return {
        ...useQuery({
            queryKey: ["getRoutes"],
            queryFn: getRoutes,
            refetchOnWindowFocus: false,
            retry: false,
            placeholderData: keepPreviousData,
        }),
    };
};

export default useRoutesQuery;
